export default "__VITE_ASSET__BHgOsjaL__"